const invalidateApolloClientCache = (client, obj, fields = null) => {
  const cacheId = client.cache.identify(obj);

  if (fields === null) client.cache.evict({ id: cacheId });
  else fields.forEach(field => client.cache.evict({ id: cacheId, fieldName: field }));

  client.cache.gc();
};

export { invalidateApolloClientCache };
